export enum TUNDR_ICONS {
  ALERT = 'alert',
  ARCHIVE = 'archive',
  ARROW_DOWN = 'arrow-down',
  ARROW_LEFT = 'arrow-left',
  ARROW_RIGHT = 'arrow-right',
  ARROW_UP = 'arrow-up',
  ARROW_UP_RIGHT = 'arrow-up-right',
  AVATAR = 'avatar',
  AWARD = 'award',
  BARCODE = 'barcode',
  BOX = 'box',
  BUILDING = 'building',
  CALENDAR = 'calendar',
  CALENDAR_BLANK = 'calendar-blank',
  CANCEL = 'cancel',
  CARD = 'card',
  CARD_BLOCK = 'card-block',
  CARD_NOT_ACTIVE = 'card-not-active',
  CARD_PLUS = 'card-plus',
  CARD_REFRESH = 'card-refresh',
  CARD_SOLID = 'card-solid',
  CART = 'cart',
  CHAT = 'chat',
  CHECK = 'check',
  CHECK_CIRCLE = 'check-circle',
  CHECK_CIRCLE_SOLID = 'check-circle-solid',
  CHEVRON_DOWN = 'chevron-down',
  CHEVRON_LEFT = 'chevron-left',
  CHEVRON_RIGHT = 'chevron-right',
  CHEVRON_UP = 'chevron-up',
  CLOCK = 'clock',
  CLOSE = 'close',
  COINS = 'coins',
  COINS_SOLID = 'coins-solid',
  COPY = 'copy',
  CREDIT_LIMIT = 'credit-limit',
  CROSS = 'cross',
  DASHBOARD = 'dashboard',
  DASHBOARD_SOLID = 'dashboard-solid',
  DATABASE = 'database',
  DELETE = 'delete',
  DEPOSIT = 'deposit',
  DEPOSIT_SOLID = 'deposit-solid',
  DOTS_HORIZONTAL = 'dots-horizontal',
  DOWNLOAD = 'download',
  ERROR = 'error',
  ERROR_SOLID = 'error-solid',
  EURO = 'euro',
  EXCLAMATION_OCTAGON = 'exclamation-octagon',
  EXCLAMATION_TRIANGLE = 'exclamation-triangle',
  EXTERNAL_LINK = 'external-link',
  EYE_CLOSE = 'eye-close',
  EYE_OPEN = 'eye-open',
  FILE = 'file',
  FILE_BLANK = 'file-blank',
  FILE_DOWNLOAD = 'file-download',
  FILE_DOWNLOAD_SOLID = 'file-download-solid',
  FILE_EDIT = 'file-edit',
  FILE_SHIELD = 'file-shield',
  FILE_SOLID = 'file-solid',
  FILTER = 'filter',
  FINGERPRINT = 'fingerprint',
  FOLDER = 'folder',
  FOLDER_SOLID = 'folder-solid',
  GIFT = 'gift',
  GIFT_SOLID = 'gift-solid',
  HOME = 'home',
  HOME_SOLID = 'home-solid',
  IMPORT = 'import',
  INFO = 'info',
  LEAF = 'leaf',
  LIGHTBULB = 'lightbulb',
  LIGHTNING = 'lightning',
  LIGHTNING_SOLID = 'lightning-solid',
  LIST = 'list',
  MAIL = 'mail',
  MAILBOX = 'mailbox',
  MANAGE_COLUMNS = 'manage-columns',
  MINUS = 'minus',
  MOBILE = 'mobile',
  MONEY_INSERT = 'money-insert',
  NOTCHES = 'notches',
  NOTE = 'note',
  OFF = 'off',
  OPTIONS = 'options',
  PDF = 'pdf',
  PEN = 'pen',
  PEOPLE = 'people',
  PEOPLE_SOLID = 'people-solid',
  PERCENT = 'percent',
  PHONE = 'phone',
  PIN = 'pin',
  PIN_SOLID = 'pin-solid',
  PLUS = 'plus',
  QRCODE = 'qrcode',
  QUESTION = 'question',
  RECEIPT = 'receipt',
  RECEIPT_SOLID = 'receipt-solid',
  REFRESH = 'refresh',
  SCROLL_TOP = 'scroll-top',
  SEARCH = 'search',
  SETTINGS = 'settings',
  SHARE = 'share',
  SIGN_ALT = 'sign-alt',
  SIGNOUT = 'signout',
  SLIDE_LEFT = 'slide-left',
  SLIDE_RIGHT = 'slide-right',
  SORT = 'sort',
  SORT_ASCENDING = 'sort-ascending',
  SORT_DESCENDING = 'sort-descending',
  SORTABLE = 'sortable',
  STORE = 'store',
  STORE_SOLID = 'store-solid',
  SWITCH = 'switch',
  SYNC = 'sync',
  TAG = 'tag',
  TAG_SOLID = 'tag-solid',
  TRAIN = 'train',
  TRASH = 'trash',
  TREES = 'trees',
  TRUCK = 'truck',
  TRUCK_FAST = 'truck-fast',
  UNDO = 'undo',
  UNIVERSITY = 'university',
  UPLOAD = 'upload',
  USER = 'user',
  USER_CHECK = 'user-check',
  USER_SETTINGS = 'user-settings',
  USER_SETTINGS_SOLID = 'user-settings-solid',
  UTENSILS = 'utensils',
  UTENSILS_SOLID = 'utensils-solid',
  VIRTUAL_CARD = 'virtual-card',
  WALLET = 'wallet',
  WRENCH = 'wrench',
  WRENCH_SOLID = 'wrench-solid',
}
